import React from 'react';
import Icon from '../../../components/AppIcon';

const StakeholderImpactAnalysis = ({ stakeholders }) => {
  const getImpactColor = (level) => {
    switch (level) {
      case 'Positif Tinggi':
        return 'text-success bg-success/10';
      case 'Positif Sedang':
        return 'text-primary bg-primary/10';
      case 'Netral':
        return 'text-muted-foreground bg-muted';
      case 'Negatif Sedang':
        return 'text-warning bg-warning/10';
      case 'Negatif Tinggi':
        return 'text-destructive bg-destructive/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStakeholderIcon = (type) => {
    const icons = {
      board: 'Users',
      management: 'Briefcase',
      farmers: 'Tractor',
      employees: 'UserCheck',
      customers: 'ShoppingCart',
      investors: 'TrendingUp'
    };
    return icons?.[type] || 'User';
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="Users" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold">Analisis Dampak Stakeholder</h3>
          <p className="text-sm text-muted-foreground">Evaluasi pengaruh keputusan terhadap pemangku kepentingan</p>
        </div>
      </div>
      <div className="space-y-4">
        {stakeholders?.map((stakeholder, index) => (
          <div key={index} className="p-4 rounded-lg border border-border hover:border-primary/30 transition-colors duration-250">
            <div className="flex items-start gap-4 mb-3">
              <div className="w-12 h-12 rounded-xl bg-primary/5 flex items-center justify-center flex-shrink-0">
                <Icon name={getStakeholderIcon(stakeholder?.type)} size={24} color="var(--color-primary)" />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-semibold">{stakeholder?.name}</h4>
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${getImpactColor(stakeholder?.impactLevel)}`}>
                    {stakeholder?.impactLevel}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground mb-3">
                  {stakeholder?.description}
                </p>
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex items-start gap-2">
                <Icon name="Target" size={14} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium mb-1">Kepentingan Utama</p>
                  <p className="text-xs text-muted-foreground">{stakeholder?.primaryConcern}</p>
                </div>
              </div>

              <div className="flex items-start gap-2">
                <Icon name="AlertCircle" size={14} color="var(--color-warning)" className="mt-1 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium mb-1">Risiko Potensial</p>
                  <p className="text-xs text-muted-foreground">{stakeholder?.potentialRisk}</p>
                </div>
              </div>

              <div className="flex items-start gap-2">
                <Icon name="CheckCircle2" size={14} color="var(--color-success)" className="mt-1 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium mb-1">Strategi Mitigasi</p>
                  <p className="text-xs text-muted-foreground">{stakeholder?.mitigationStrategy}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StakeholderImpactAnalysis;